<template>
  <a-select
    :allow-clear="false"
    :filter-option="false"
    :label-in-value="false"
    mode="multiple"
    :options="options"
    :show-search="false"
    :max-tag-count="2"
    v-model="selected"
    @change="change"
    placeholder="全部级别"
  ></a-select>
</template>

<script>
export default {
  name: 'SeverityMultipleSelect',
  props: {
    value: {
      type: Array
    }
  },
  data () {
    return {
      options: [
        {
          label: '紧急',
          key: 'disaster'
        },
        {
          label: '严重',
          key: 'high'
        },
        {
          label: '普通',
          key: 'average'
        },
        {
          label: '预警',
          key: 'warning'
        }
      ],
      selected: []
    }
  },
  mounted () {
    if (this.value) {
      this.selected = this.value
    }
  },
  methods: {
    change (value) {
      this.$emit(
        'input',
        value
      )
    }
  }
}
</script>
